import { useEffect, useRef } from 'react';

const IDLE_RELOAD_THRESHOLD_MS = 10 * 60 * 1000; // 10 minutos

export function useAutoReloadOnIdle() {
  const hiddenAtRef = useRef<number | null>(null);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Aba foi pra background: marca o momento
        hiddenAtRef.current = Date.now();
      } else {
        // Aba voltou a ficar visível: verifica quanto tempo passou
        if (hiddenAtRef.current !== null) {
          const elapsed = Date.now() - hiddenAtRef.current;
          if (elapsed >= IDLE_RELOAD_THRESHOLD_MS) {
            // Passou 10min+ em background: força reload completo (equivalente a F5)
            window.location.reload();
          }
          hiddenAtRef.current = null;
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);
}
